<ng-container *ngIf="isClickable; else nonClickableItem">
  <a
    class="link-hover underline-hover {{ customClasses }} font-label-medium"
    tabindex="0"
    [attr.data-testid]="'summary-clickable-item-' + type"
    (click)="clickAction.emit(type)"
    (keydown.enter)="clickAction.emit(type)"
  >
    <ng-container [ngTemplateOutlet]="content" />
  </a>
</ng-container>
<ng-template #nonClickableItem>
  <span class="{{ customClasses }} font-label-medium" tabindex="0" [attr.data-testid]="'summary-item-' + type">
    <ng-container [ngTemplateOutlet]="content" />
  </span>
</ng-template>
<ng-template #content>
  <ng-content select=".content" />
</ng-template>
